import { bold, button, columnCenter, h5, h6, rowCenter, subTitle2 } from '../../../resources/styles';
import { makeStyle } from "../../../utils";

const styles = {};


styles['container'] = makeStyle({ overflowY: 'auto', height: '100%' });



styles['image_containter'] = makeStyle({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: '64px 0px',
    position: 'relative',
}, {}, {}, { padding: '24px 0px' });


styles['image'] = makeStyle({
    position: 'absolute', top: 0,
    objectFit: 'cover',
    height: '100%', width: '100%',
    backgroundColor: '#d0d9e3',
    filter: 'blur(1.5px) brightness(1.15)',
});


styles['left_card'] = makeStyle({ maxWidth: 556, padding: 12, margin: 12, color: 'white', fontSize: 19, zIndex: 1 }, {}, {}, { fontSize: 16 });

styles['left_card_heading'] = makeStyle({ ...h5, lineHeight: '36px', fontSize: 30, color: 'var(--theme-color)' }, {}, {}, { fontSize: 22 });


styles['card_divider'] = makeStyle({}, { width: 200 });


styles['right_card'] = makeStyle({
    width: 300, borderRadius: 6, padding: 24, margin: 12, ...columnCenter, ...h6, ...bold, fontSize: 18,

    background: '#ffffff7d',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37 )',
    backdropFilter: 'blur(4px)',
    borderRadius: 10,
    border: '1px solid rgba(255, 255, 255, 0.18 )',
    textAlign: 'center',
    zIndex: 1,
});


styles['go_to_top'] = makeStyle({
    ...rowCenter, ...subTitle2,
    position: 'sticky',
    bottom: '12px',
    padding: '8px 16px',
    width: 'max-content',
    margin: '16px auto',
    borderRadius: '24px',
    backgroundColor: 'black',
    color: 'white',
    zIndex: 6,
    cursor: 'pointer',
});

styles['carousel_item'] = makeStyle({
    width: '100%', minHeight: 400, ...rowCenter, justifyContent: 'center',
    padding: 24, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'
});

styles['carousel_text'] = makeStyle([h5, {
    maxWidth: 600,
    padding: 32,
    background: '#ffffff0d',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
    backdropFilter: 'blur(4px)',
    borderRadius: 10,
    border: '1px solid rgba(255, 255, 255, 0.18)',
    textAlign: 'center',
    color: 'white'
}]);

styles['cta_button'] = makeStyle({
    borderRadius: 6,
    backgroundColor: 'var(--theme-color)',
    textAlign: 'center',
    color: 'white',
    padding: '8px 24px',
    margin: '24px auto 0',
    display: 'flex',
    alignItems: 'center',
    ...button,
});


export default styles;